const SectionUnsubscribe = Class(
	/**
	 * @lends {SectionUnsubscribe#}
	 */
	{
		bodyClass: 'small-nav grey',

		__construct() {
			this.node = mkE({
				tag: 'div',
				id: 'unsubscribe',
				className: 'container',
				els: [
					this._content = mkE({
						tag: 'div',
						id: 'unsubscribe-content'
					})
				]
			}).append(this.layout.ct());
		},

		draw() {
			new RPC('/api/web_rpc.php').send('getSubscriptionData', {
				id: this.url.get.v('id'),
				list: this.url.get.v('l'),
				campaign: this.url.get.v('c')
			}, this._onSubscriptionData);
		},

		_onSubscriptionData(data) {
			if (data.error && !data.showError) {
				Section.navigate(D.url('/'), {
					popState: true
				});
				return;
			} else if (data.error) {
				this._drawError();
			} else if (data.unsubscribed) {
				this._drawUnsubscribed(data.showForm || false);

				if (data.showForm) {
					this._drawUnsubscribeForm();
				}
			}
			this.ready();
		},

		_drawError() {
			mkE({
				tag: 'div',
				className: 'title',
				text: D.Lang.get('unsubscribe.error.title')
			}).append(this._content);
			mkE({
				tag: 'div',
				className: 'text',
				text: D.Lang.get('unsubscribe.error.text')
			}).append(this._content);
		},

		_drawUnsubscribed(form) {
			mkE({
				tag: 'div',
				className: 'title',
				text: D.Lang.get('unsubscribe.success.title')
			}).append(this._content);
			mkE({
				tag: 'div',
				className: 'text',
				text: D.Lang.get('unsubscribe.success.text' + (form ? 'Form' : ''))
			}).append(this._content);
		},

		_drawUnsubscribeForm() {
			this._checkboxes = {};
			let checkboxes = mkE({
				tag: 'div',
				className: 'checkboxes'
			}).append(this._content);
			let items = [
				'signUp',
				'actual',
				'tooMuch',
				'dontWant',
				'other'
			];
			items.forEach(item => {
				this._checkboxes[item] = new T.Form.CheckBox({
					caption: D.Lang.get('unsubscribe.boxes.' + item),
					onChange: D.closure(this, this._onCheckboxChange, item)
				}).append(checkboxes);
			});
			this._reasonInput = new T.Form.TextArea({
				border: true
			});
			this._button = mkE({
				tag: 'button',
				className: 'button button-pink button-large',
				text: D.Lang.get('unsubscribe.button'),
				onclick: this._submitForm
			}).append(this._content);
		},

		_onCheckboxChange(checkbox) {
			if (checkbox !== 'other') {
				return;
			}
			let status = this._checkboxes[checkbox].value();
			if (!status) {
				this._reasonInput.remove();
			} else {
				D.insertBefore(this._reasonInput.node, this._button);
				this._reasonInput.focus();
			}
		},

		_submitForm() {
			let reasons = [];
			for (let item in this._checkboxes) {
				if (!this._checkboxes.hasOwnProperty(item)) {
					continue;
				}
				if (this._checkboxes[item].value()) {
					reasons.push(item);
				}
			}
			let data = {
				reasons: reasons
			};
			if (reasons.indexOf('other') !== -1) {
				data.text = this._reasonInput.value();
			}
			D.loadingOverlay(document.body);
			new RPC('/api/web_rpc.php').send('unsubscribeReason', {
				data: data
			}, this._onUnsubscribeReason);
		},

		_onUnsubscribeReason() {
			D.removeLoadingOverlay(document.body);
			clearNode(this._content);
			mkE({
				tag: 'div',
				className: 'title',
				text: D.Lang.get('unsubscribe.finish.title')
			}).append(this._content);
			mkE({
				tag: 'div',
				className: 'text',
				text: D.Lang.get('unsubscribe.finish.text')
			}).append(this._content);
			mkE({
				tag: 'a',
				href: D.url('/'),
				className: 'button button-pink button-large',
				text: D.Lang.get('unsubscribe.home')
			}).append(this._content);
		}
	},
	Section
);
